import Cookies from 'js-cookie';

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this;
    this.body = document.querySelector('body');
    this.activeClass = 'cart-drawer-is-open';
    this.cartIconBubble = document.querySelector('cart-icon-bubble');

    this.closeButtons = this.querySelectorAll('[data-cart-button-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.promoWrapper = this.querySelector('[data-promo-remove-wrapper]');

    this.removePromo();
    this.handleProgressBar();
    this.handleOrderUpgrade();
    this.handlePromos();
  }

  handleOrderUpgrade() {
    if (this.querySelector('[data-order-upgrade]')) {
      let data = this.querySelector('[data-order-upgrade]').dataset;
      let giftCard = parseInt(data.orderUpgradeGift);
      let insurance = parseInt(data.orderUpgradeInsurance);
      if (this.querySelector('[data-upgrade-order-trigger]')) {
        this.querySelector('[data-upgrade-order-trigger]').addEventListener('click', (event) => {
          if (event.target.checked) {
            this.addOrderUpgrade();
          } else {
            let updates = {};
            updates[insurance] = 0
            updates[giftCard] = 0
    
            let body = JSON.stringify({
              updates,
              sections: this.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname
            });
            
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then((response) => response.json())
              .then((parsedState) => {
                this.renderContents(parsedState);
              })
              .catch((e) => {
                console.error(e);
              })
          }
        })
      }
    }
  }

  addOrderUpgrade() {
    let upgradeOrder = false;
    this.orderUpgrade = document.querySelector('[data-order-upgrade]');

    if (this.orderUpgrade) {
      let insurace_id = this.orderUpgrade.dataset.orderUpgradeInsurance;
      let insurance_active = this.orderUpgrade.dataset.orderUpgradeInsuranceActive;
      let giftCard_id = this.orderUpgrade.dataset.orderUpgradeGift;
      let giftCard_active = this.orderUpgrade.dataset.orderUpgradeGiftActive;
      this.items = [];
      let object = {};
      if (giftCard_id || insuraceId) {
        if (insurace_id && insurance_active == 'false') {
          let properties = {};
          properties._promo_product = 'false';
          properties._funnel = 'order upgrade';
          properties._funnel_location = 'cart drawer';
          properties._funel_type = 'manually added';
          properties._promo = false;
          properties._promo_discount = 0;
          properties._promo_discount_type = 'percentage';
          object = {};
          object = {
            quantity: 1,
            id: parseInt(insurace_id),
            properties
          }
          this.items.push(object);
          upgradeOrder = true;
        }
        if (giftCard_id && giftCard_active == 'false') {
          let properties = {};
          properties._promo_product = 'true';
          properties._funnel = 'order upgrade';
          properties._funnel_location = 'cart drawer';
          properties._funel_type = 'manually added';
          properties._promo = true;
          properties._promo_discount = 100;
          properties._promo_discount_type = 'percentage';
          object = {};
          object = {
            quantity: 1,
            id: parseInt(giftCard_id),
            properties
          }
          this.items.push(object);
          upgradeOrder = true;
        }
      }
    }

    if (upgradeOrder && this.items.length > 0) {

      let body = JSON.stringify({
        items: this.items,
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });
      
      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.json())
        .then((parsedState) => {
          this.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
    }
  }

  removePromo() {
    this.querySelectorAll('[data-promo-remove-init]').forEach((remove) => {
      remove.addEventListener('click', (event) => {
        event.preventDefault();
        this.promoWrapper.classList.remove('hidden');
        this.promoWrapper.querySelectorAll('[data-promo-remove]').forEach((button) => {
          button.addEventListener('click', (event) => {
            let itemId = remove.dataset.itemId;
            if (event.target.dataset.promoRemove == 'true') {
              // write cookie
              let cookie = Cookies.get('refused_promos');
              if (typeof cookie !== 'undefined') {
                if (cookie.length == 0) {
                  Cookies.set('refused_promos', itemId, { expires: 365 })
                } else {
                  let newCookie = cookie + ',' + itemId;
                  Cookies.set('refused_promos', newCookie, { expires: 365 })
                }
              } else {
                Cookies.set('refused_promos', itemId, { expires: 365 })
              }
              let updates = {};
              updates[itemId] = 0
  
              let body = JSON.stringify({
                updates,
                sections: this.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
              });
              
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => response.json())
                .then((parsedState) => {
                  this.renderContents(parsedState);
                })
                .catch((e) => {
                  console.error(e);
                })
            } else {
              this.promoWrapper.classList.add('hidden');
            }
          });
        })
      })
    });
  }

  handleProgressBar() {
    this.progressBar = document.querySelector('[data-progressbar]');
    if (this.progressBar && this.progressBar.dataset.progressbar) {
      let freeGiftVariant = JSON.parse(this.progressBar.dataset.progressbar).free_gift_variant;
      let cookie = Cookies.get('refused_promos');
      if (typeof cookie !== 'undefined') {
        cookie.split(',').forEach((cookie) => {
          if (cookie == freeGiftVariant) {
            this.progressBar.classList.add('hidden');
          }
        })
      }
    }
    let free_shipping_event = localStorage.getItem('free_shipping_event');
    if (free_shipping_event) {
      document.querySelector('.progressbar-1').classList.add('shipping');
    }
  }

  open() {

    if (sessionStorage.getItem('cart_drawer_is_open')) {
      sessionStorage.setItem('cart_drawer_is_open', true);
    } else {
      sessionStorage.setItem('cart_drawer_is_open', true);
      if (window.abTest) {
        window.igEvents = window.igEvents || [];
        window.igEvents.push({
          "event": "Opened cart"
        })
      }
    }

    this.body.classList.add(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', true);

    document.querySelectorAll('[data-max-width]').forEach((element) => {
      let maxWidth = element.dataset.maxWidth;
      element.style.maxWidth = maxWidth + '%';
    })

    this.drawer.focus();
    trapFocus(this.drawer);
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.body.classList.remove(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', false);

    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus();
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      if (section?.selector) {
        let selector = document.querySelector(section.selector);
        if (selector) {
          selector.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
      }
    });

    // Re-bind the close drawer buttons
    this.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
      btn.addEventListener('click', this.close.bind(this))
    );

    this.handlePromos();
    this.removePromo();
    this.handleOrderUpgrade();

    document.querySelectorAll('[data-max-width]').forEach((element) => {
      let maxWidth = element.dataset.maxWidth;
      element.style.maxWidth = maxWidth + '%';
    })
  }

  // product promos
  handlePromos() {
    if (document.querySelector('[data-product-drawer-promos]')) {
      let promos = document.querySelector('[data-product-drawer-promos]');
      if (promos.dataset && promos.dataset.productDrawerPromos) {
        let promoData = JSON.parse(promos.dataset.productDrawerPromos);
        let enable_promo = promoData.promo_enabled;
        let mystery_gift = promoData.mystery_gift;
        let url_promo = promoData.url_promo;
        let url_promo_attribute = promoData.url_promo_attribute;

        if (sessionStorage.getItem('url_promo')) {
          if (document.querySelector('.progressbar-2')) {
            document.querySelector('.progressbar-2').classList.remove('hidden');
            window.abTest = true;
          }
        }

        if (enable_promo) {
          let promo_variant_id = promoData.promo_variant_id;
          let add_product = promoData.add_product;

          let cookie = Cookies.get('refused_promos');
          let add_item = true;
          if (typeof cookie !== 'undefined') {
            cookie.split(',').forEach((id) => {
              if (parseInt(id) == parseInt(promo_variant_id)) {
                add_item = false;
              }
            });
          }

          console.log('add_item', add_item, url_promo, url_promo_attribute);

          // url based
          if (url_promo && url_promo_attribute) {
            add_item = sessionStorage.getItem('url_promo') || false;
            let attribute = 'promo=' + url_promo_attribute;
            console.log('add_item', add_item);
            if (location.search.indexOf(attribute) > -1) {
              add_item = true;
              sessionStorage.setItem('url_promo', add_item);
              document.querySelector('.progressbar-2').classList.remove('hidden');
              window.abTest = true;
            }
          }

          // add product
          if (add_product && add_item) {

            let properties = {};
            properties._promo_product = 'true';
            properties._funnel = 'gifts';
            properties._funnel_location = 'global';
            properties._funel_type = 'automatically added / with removal';
            properties._promo = true;
            properties._promo_discount = 100;
            properties._promo_discount_type = 'percentage';

            if (mystery_gift && window.mystery_gift_ab) {
              properties._mystery_gift = 'true';
              properties._mystery_gift_title = promoData.mystery_gift_title;
              properties._mystery_gift_image = promoData.mystery_gift_image;
            }
            
            let body = JSON.stringify({
              id: promo_variant_id,
              quantity: 1,
              properties,
              sections: this.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname
            });
            
            fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
              .then((response) => response.json())
              .then((parsedState) => {
                this.renderContents(parsedState);
              })
              .catch((e) => {
                console.error(e);
              })
          }
        }
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '[data-cart-drawer]',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest('cart-drawer')) {
      this.close();
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
